import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompletedContinuationClass;
function CompletedContinuation() {
  if (CompletedContinuationClass === VOID) {
    class $ {
      get_context_h02k06_k$() {
        // Inline function 'kotlin.error' call
        var message = 'This continuation is already complete';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      resumeWith_ol1nfv_k$(result) {
        // Inline function 'kotlin.error' call
        var message = 'This continuation is already complete';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
      resumeWith_rk9gbt_k$(result) {
        return this.resumeWith_ol1nfv_k$(result);
      }
      toString() {
        return 'This continuation is already complete';
      }
    }
    initMetadataForObject($, 'CompletedContinuation', VOID, VOID, [Continuation()]);
    CompletedContinuationClass = $;
  }
  return CompletedContinuationClass;
}
var CompletedContinuation_instance;
function CompletedContinuation_getInstance() {
  return CompletedContinuation_instance;
}
//region block: init
CompletedContinuation_instance = new (CompletedContinuation())();
//endregion
//region block: exports
export {
  CompletedContinuation_instance as CompletedContinuation_instancep2g1gjehm3d4,
};
//endregion

//# sourceMappingURL=CoroutineImpl.mjs.map
